<template>
  <div class="lobby-card-wrapper">
    <div class="content">
      <img v-if="logoUrl" class="logo" :src="logoUrl" :alt="t('logo')" />
      <slot />
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    logoUrl: {
      type: String,
      default: '',
    },
  },
  setup() {
    const { t } = useI18n();
    return {
      t,
    };
  },
});
</script>
<style lang="scss" scoped>
@import '@getaccept/lib-shared/src/lobby/scss/lobby-card-wrapper';
</style>
